/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-key */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Button, Divider, Typography, DialogActions } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {
  meetingColor,
  timeZoneWiseTime,
  formattedTimeSlot,
  timeZoneAbbreviation,
  createZoomMeetingUrl,
  timeZonWiseDateTime,
  checkCallType
} from '../../components/common';
import { API } from '../../../../api';
import { toast } from 'react-toastify';
import CalendarLoader from './CalendarLoader';
import '../../../../assets/style/pagination.css';
import PostCallPopup from '../chat/PostCallPopup';
import CallBookingModal from '../CallBookingModal';
import { callActionFlag } from './CalendarFunctions';
import RejectionCallModal from './RejectionCallModal';
import AddIcon from '@mui/icons-material/Add';
import MySkeleton from '../../../../components/Skeleton';
import MyPagination from '../../components/MyPagination';
import CancelationCallModal from './CancelationCallModal';
import { getUserDetails } from '../../../../utils/orgName';
import { BooleanLiteralTypeAnnotation } from '@babel/types';
import SeeBookingDetailsModal from './SeeBookingDetailsModal';
import useCallDetails from '../../../../queries/useCallDetails';
import useProfileDetails from '../../../../hooks/useProfileDetails';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { fetchCallsCount } from '../../../../redux/slices/callCountSlice';
import useResponsiveScreenSwitch from '../../../../utils/useResponsiveScreenSwitch';
import { fetchCommunityMembers } from '../../../../redux/slices/acs-community-members/acsCommunityMembers';

export interface CallRowData {
  meetingId: string;
  _id: string;
  callDate: string;
  callTime: string;
  callTitle: string;
  callTimeInterval: number;
  participantsUser: {
    mid: string;
    callRejectStatus: boolean;
    isCallJoined: boolean; // Add the isCallJoined property
    voteFlag: boolean; // Add the voteFlag property
  }[];
  chatType?: string;
  callBookedWith?: {
    id: string;
    displayName: string;
    headshot: string;
  };
  callBookedBy?: {
    id: string;
    displayName: string;
    headshot: string;
  };
  description: string;
  callStatus: string;
  meetingType: string;
  objective?: any;
}

const Calendar = () => {
  const dispatch = useAppDispatch();
  const userData = useAppSelector((state) => state.userProfile.data);
  const timezone = userData?.personal_details?.timezone || '';
  const { userId } = getUserDetails();
  const userProfileDetails = useProfileDetails();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const userCallsData = useCallDetails(page, pageSize);
  const allTotalObjects = userCallsData.allTotelCount;
  const { forMobile } = useResponsiveScreenSwitch();
  const [isCallEditing, setIsCallEditing] = useState(false);
  const meetingFilters = useMemo(() => meetingColor(), []);
  const [activeFilters, setActiveFilters] = useState<string[]>(() => meetingFilters.map((filter) => filter.value));
  const toggleFilter = (value: string) => {
    setActiveFilters((prev) => {
      if (prev.includes(value)) {
        return prev.filter((filter) => filter !== value);
      }
      return [...prev, value];
    });
  };

  useEffect(() => {
    if (page !== 0) {
      userCallsData.refetch();
    }
  }, [page]);

  const totalPages = Math.ceil(allTotalObjects / pageSize);

  const handlePageChange = (newPage: any) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const callRows: CallRowData[] = userCallsData?.data || [];
  const [callMeetingId, setMetingId] = useState();
  const [cancelCallMeetingId, setcancelCallMeetingId] = useState();
  const [rejectCallMeetingId, setrejectCallMeetingId] = useState();
  const [openPostCallPopup, setOpenPostCallPopup] = useState(true);
  const loading = userCallsData.isLoading; // Loading

  /** Open Rejection Reason modal */
  const [openRejectionCall, setRejectionCallOpen] = useState(false);
  const handleRejectionCall = (meetingId: any, type: string) => {
    setMetingId(meetingId);
    setRejectionCallOpen(true);
    if (type === 'modal') {
      setopenCallbookingDetailsModal(false);
    }
  };

  const handleCallCancellation = () => {
    setcancelCallMeetingId(callMeetingId);
  };

  const closeRejectionModal = () => {
    userCallsData.refetch();
    setRejectionCallOpen(false);
  };

  const handleClosePostCallPopup = () => {
    userCallsData.refetch();
    setOpenPostCallPopup(false);
  };

  /** Open Call Cancelation modal */
  const [openCancelationCall, setCancelationCallOpen] = useState(false);
  const handleCancelationCall = (meetingId: any, type: string) => {
    setMetingId(meetingId);
    setCancelationCallOpen(true);
    if (type === 'modal') {
      setopenCallbookingDetailsModal(false);
    }
  };
  const handleCallRejection = () => {
    setrejectCallMeetingId(callMeetingId);
  };
  const closeCancelModal = () => {
    userCallsData.refetch();
    setCancelationCallOpen(false);
  };

  /** See Booking Details Modal */
  const acsChannelParticipants = useAppSelector((state) => state.acsChannelParticipants.data);
  // const allReviewMeetingId: any[] = [];
  const [openCallbookingDetailsModal, setopenCallbookingDetailsModal] = useState(false);
  const [isCalendarOpen, setCalendarOpen] = useState(false);
  const [currentMeetingIndex, setCurrentMeetingIndex] = useState(0);
  const [allattendeeDetails, setallAttendeeDetails] = useState([]);
  const [bookedCallDetails, setBookedCallDetails] = useState<CallRowData[]>([]);
  const handleSeeBookingDetails = (attendeeDetails: any, callId: any) => {
    const filteredData: CallRowData[] = callRows?.filter((item: { _id: string }) => item._id === callId);
    const filteredMidValues: any[] = filteredData
      ?.map((item: CallRowData) => {
        if (item.participantsUser.some((participant) => participant.mid === userId)) {
          if (item?.chatType === 'Chats') {
            return [item?.callBookedBy?.id, item?.callBookedWith?.id];
          } else {
            return [item?.callBookedBy?.id];
          }
        } else {
          return [item?.callBookedBy?.id];
        }
      })
      .flat();
    const filteredattendeeDetails = attendeeDetails.filter(
      (item: { mid: any }) => !filteredMidValues.includes(item.mid)
    );
    setBookedCallDetails(filteredData);
    setallAttendeeDetails(filteredattendeeDetails);
    setopenCallbookingDetailsModal(true);
  };

  const closeSeeBookingDetailsModal = () => {
    userCallsData.refetch();
    setopenCallbookingDetailsModal(false);
  };

  const getChannels = () => {
    dispatch(
      fetchCommunityMembers({
        orgId: getUserDetails().orgId,
        location: getUserDetails().location
      })
    );
  };

  useEffect(() => {
    dispatch(fetchCallsCount(getUserDetails().location));
    getChannels();
  }, []);
  useEffect(() => {
    userCallsData.refetch();
  }, []);

  const attendeesImage = (participantsUserRow: { headshot: string }[], callId: any) => {
    const imageSources = participantsUserRow.slice(0, 3).map((attendee) => attendee?.headshot);
    return (
      <Box display="flex" gap="8px" alignItems="center">
        {participantsUserRow.length > 2 && (
          <>
            <Box className="CallsAttendeesImages">
              {imageSources.map((src, index) => (
                <img
                  key={index}
                  src={src}
                  alt={`Attendee ${index + 1}`}
                  className={`Image${index + 1} cursor-pointer`}
                  onClick={() => handleSeeBookingDetails(participantsUserRow, callId)}
                />
              ))}
            </Box>
            <Typography
              variant="h6"
              className="cursor-pointer"
              color="#0071A9"
              onClick={() => handleSeeBookingDetails(participantsUserRow, callId)}
              noWrap
            >
              See all Attendees
            </Typography>
          </>
        )}
      </Box>
    );
  };

  const rejectCancelCallButton = (callsData: any, type: string) => {
    const isUserInParticipants = callsData.participantsUser?.some(
      (participant: { mid: string }) => participant.mid === userId
    );

    if (!isUserInParticipants) {
      return null; // Do not render anything if the member is not in participantsUser
    }

    let flag = 0;
    if (callsData?.callBookedBy?.id === userId) {
      flag = 1;
    }
    const meetingId = callsData?.meetingId;

    return (
      <>
        {flag === 1 && meetingId !== cancelCallMeetingId && (
          <Button
            variant="outlined"
            className={type === 'page' ? 'CallsPageBtn MeetingCancelButton' : ''}
            color={type === 'page' ? 'error' : 'secondary'}
            fullWidth={type !== 'page'}
            onClick={() => handleCancelationCall(meetingId, type)}
          >
            Cancel
          </Button>
        )}

        {flag !== 1 && meetingId !== rejectCallMeetingId && (
          <Button
            variant="outlined"
            className={type === 'page' ? 'CallsPageBtn MeetingCancelButton' : ''}
            color={type === 'page' ? 'error' : 'secondary'}
            fullWidth={type !== 'page'}
            onClick={() => handleRejectionCall(meetingId, type)}
          >
            Reject
          </Button>
        )}
      </>
    );
  };

  const joinCallButton = (callsData: any, type: string) => {
    const meetingId = callsData?.meetingId;
    const isUserInParticipants = isUserInParticipantsArray(callsData);
    const callStartTimestamp = new Date(callsData.callDate + 'T' + callsData.callTime + 'Z').getTime();
    const currentTimestamp = new Date().getTime();
    const tenMinutesBefore = callStartTimestamp - 10 * 60 * 1000;
    const isWithinJoinWindow = currentTimestamp >= tenMinutesBefore;

    if (meetingId !== cancelCallMeetingId && meetingId !== rejectCallMeetingId && isUserInParticipants) {
      return (
        <Button
          className={type === 'page' ? 'CallsPageBtn MeetingJoinButton' : ''}
          variant="contained"
          color="primary"
          fullWidth={type !== 'page'}
          key={callsData?._id}
          disabled={false}
          onClick={() =>
            handleGoToCallIconClick(
              callsData?.callTimeInterval,
              callsData?.callDate,
              callsData?.callTime,
              callsData?.meetingId,
              isRejoin(callsData),
              callsData?.callBookedBy,
              callsData?.meetingType,
              callsData?.meetingLink
            )
          }
        >
          {isRejoin(callsData) ? 'Rejoin' : 'Join'}
        </Button>
      );
    } else {
      // Return null or an empty fragment if the member is not in the participants array
      return null;
    }
  };

  const isUserInParticipantsArray = (callsData: any) => {
    const userId = getUserDetails().userId;
    return callsData.participantsUser?.some((user: { mid: string }) => user.mid === userId);
  };

  const isRejoin = (callsData: any) => {
    const data = callsData.participantsUser?.find((user: { mid: string }) => user.mid === getUserDetails().userId);
    return data ? data.isCallJoined : false;
    // true => go to call
    // false => rejoin
  };

  const handleGoToCallIconClick = (
    callTimeInterval: number,
    callDate: string,
    callTime: string,
    meetingId: string,
    isRejoin: BooleanLiteralTypeAnnotation,
    callBookedBy: any,
    meetingType: string,
    meetingLink: string
  ) => {
    const baseUrl = window.location.origin;
    // call start time
    const callStartTimestamp = new Date(callDate + 'T' + callTime + 'Z').getTime();
    const callStartUnixTime = Math.floor(callStartTimestamp / 1000);
    const currentTimestamp = new Date().getTime();
    const currentcallStartUnixTime = Math.floor(currentTimestamp / 1000);
    const currentUnixTime = Math.floor(currentTimestamp / 1000);
    const callEndUnixTime = currentUnixTime + callTimeInterval * 60;

    if (currentUnixTime + 300 >= callStartUnixTime) {
      // if current time is greater than call time
      if (currentUnixTime > callEndUnixTime) {
        toast.error('This meeting has already taken place');
      } else {
        if (!isRejoin) {
          isJoinCall(meetingId);
        }
        if (meetingType === 'Dosen') {
          const url = createZoomMeetingUrl(meetingId, callDate, callTime, callTimeInterval, callBookedBy);
          const newTab = window.open(url, '_blank');
          newTab?.focus();
        } else {
          const newTab = window.open(meetingLink, '_blank');
          newTab?.focus();
        }
      }
    } else {
      toast.warning('You can join the meeting from 5 minutes before the meeting time');
    }
  };

  const isJoinCall = async (meetingId: string) => {
    const { orgId } = getUserDetails();
    try {
      const response = await API.rejoinCallUpdateFlag(
        getUserDetails().userId,
        meetingId,
        orgId,
        getUserDetails().location
      );
    } catch (e) {}
  };

  const ModalDialogActions: React.FC<{ callrow: CallRowData[] }> = ({ callrow }) => {
    if (callrow[0].meetingType === 'InPerson') {
      return null;
    }
    return (
      <DialogActions>
        {callActionFlag(callrow[0], getUserDetails()?.userId) === 1 ? (
          rejectCancelCallButton(callrow[0], 'modal')
        ) : (
          <span />
        )}
        {callActionFlag(callrow[0], getUserDetails()?.userId) === 1 ? joinCallButton(callrow[0], 'modal') : <span />}
      </DialogActions>
    );
  };

  const userCallsDataRefetch = () => {
    userCallsData.refetch();
  };

  const getCallDateParts = (callRowData: CallRowData) => {
    if (!callRowData?.callDate || !callRowData?.callTime || !timezone) {
      return { month: '', day: '', weekday: '' };
    }
    const locale = 'en-US';
    const dateTime = timeZonWiseDateTime(
      callRowData.callDate.toString(),
      callRowData.callTime.toString(),
      timezone
    );

    return {
      month: dateTime.toLocaleString(locale, { month: 'short' }),
      day: dateTime.getDate().toString(),
      weekday: dateTime.toLocaleString(locale, { weekday: 'short' })
    };
  };

  const getCallStatusData = (callRowData: CallRowData) => {
    const matchingParticipant = callRowData.participantsUser?.find((user) => user.mid === userId);
    const joinedParticipantsCount =
      callRowData.participantsUser?.filter((participant) => participant.isCallJoined)?.length || 0;
    const isBookerJoined =
      callRowData.participantsUser?.some((participant) => participant.mid === callRowData?.callBookedBy?.id) || false;

    const callTypeData = checkCallType(
      callRowData.callStatus,
      callRowData.callDate,
      callRowData.callTime,
      callRowData.callTimeInterval,
      matchingParticipant?.callRejectStatus,
      joinedParticipantsCount,
      isBookerJoined
    );

    const filterMeta =
      meetingFilters.find((meeting) => meeting.color === callTypeData?.color_code) ||
      meetingFilters.find((meeting) => meeting.title === callTypeData?.title) ||
      meetingFilters[0];

    return {
      color: callTypeData?.color_code || filterMeta?.color || '#00972D',
      value: filterMeta?.value || 'Upcoming',
      label: filterMeta?.title.replace(' meeting', '') || 'Upcoming'
    };
  };

  const getMeetingTimeLabel = (callRowData: CallRowData) => {
    if (!callRowData?.callDate || !callRowData?.callTime || !timezone) {
      return '';
    }

    return `${timeZoneWiseTime(
      callRowData.callDate.toString(),
      callRowData.callTime.toString(),
      timezone
    ).toLowerCase()} (${timeZoneAbbreviation(timezone)})`;
  };

  let filteredCallRows: CallRowData[] = callRows.filter((callRow: CallRowData) => {
    const matchingParticipant = callRow.participantsUser.find((user) => user.mid === userId);
    return (
      (matchingParticipant?.isCallJoined === false || matchingParticipant?.isCallJoined === undefined) &&
      matchingParticipant?.voteFlag === false
    );
  });

  const openNextPopup = () => {
    if (currentMeetingIndex < filteredCallRows.length - 1) {
      setCurrentMeetingIndex(currentMeetingIndex + 1);
    } else {
      // when all the modals are done
      setOpenPostCallPopup(false);
      setCurrentMeetingIndex(0);
      filteredCallRows = [];
      userCallsData.refetch();
    }
  };

  useEffect(() => {}, [filteredCallRows]);

  const handleCalendar = (flag: boolean) => setCalendarOpen(flag);

  const callWithTitle = (callRow: any) => {
    let reviewModalTitle = '';
    if (callRow?.chatType === 'Chats') {
      // p2p
      reviewModalTitle =
        userId === callRow?.callBookedWith?.id
          ? callRow?.callBookedBy?.displayName
          : callRow?.callBookedWith?.displayName;
    } else {
      // group
      reviewModalTitle = callRow?.callBookedWith?.name; // group name
    }
    return reviewModalTitle;
  };

  const renderNoMeetingsMessage = () => (
    <Box p={2} className="CallsTableEmptyState">
      <Typography textAlign="center">No meetings in your calendar yet</Typography>
    </Box>
  );

  const filteredMeetings = useMemo(() => {
    if (!userCallsData?.data || activeFilters.length === 0) {
      return [];
    }
    return userCallsData.data.filter((item: CallRowData) => activeFilters.includes(getCallStatusData(item).value));
  }, [userCallsData?.data, activeFilters, timezone, userId]);

  return (
    <Box className="bodyBox CalendarPageContainer" p={{ xs: 0, sm: 2 }}>
      <Box className="CardBox CalendarCard">
        <Box className="CallsPageHeader">
          <Box className="CallsLegend">
            {loading ? (
              <MySkeleton variant="text" height={20} width={100} />
            ) : (
              <Typography className="CallsLegendCount">{`${filteredMeetings.length} Meetings`}</Typography>
            )}
            <Box className="CallsLegendDivider" />
            <Box className="CallsLegendFilters">
              <Typography className="CallsLegendFiltersLabel">Filters:</Typography>
              {meetingFilters.map((meeting, index) => {
                const label = meeting.title.replace(' meeting', '');
                const isActive = activeFilters.includes(meeting.value);
                return (
                  <button
                    type="button"
                    key={index}
                    className={`CallsLegendChip ${isActive ? 'is-active' : ''}`}
                    style={isActive ? { backgroundColor: meeting.color } : undefined}
                    onClick={() => toggleFilter(meeting.value)}
                  >
                    {label}
                  </button>
                );
              })}
            </Box>
          </Box>
          {!loading && (
            <Box className="CallsHeaderActions">
              {allTotalObjects > 10 && (
                <MyPagination
                  counts={[{ count: totalPages }]}
                  currentPage={page}
                  onPageChange={handlePageChange}
                  allTotalObjects={allTotalObjects}
                  pageSize={pageSize}
                />
              )}
              <Button
                variant="contained"
                color="primary"
                className="CallsScheduleBtn"
                id="addScheduleNewMeetingIcon"
                data-testid="calendar-new-meeting-button"
                endIcon={<AddIcon fontSize="small" />}
                onClick={() => handleCalendar(true)}
              >
                Schedule Meeting
              </Button>
            </Box>
          )}
        </Box>
        <Divider />

        <Box className="CallsTable">
          <Box className="CallsTableList">
            {loading
              ? Array.from({ length: 5 }).map((_, index) => <CalendarLoader key={index} />)
              : userCallsData.error || filteredMeetings.length === 0
              ? renderNoMeetingsMessage()
              : filteredMeetings.map((item: CallRowData) => {
                  const { month, day, weekday } = getCallDateParts(item);
                  const statusData = getCallStatusData(item);
                  const meetingTimeLabel = getMeetingTimeLabel(item);
                  const durationLabel =
                    typeof item?.callTimeInterval === 'number'
                      ? formattedTimeSlot(item.callTimeInterval).toLowerCase()
                      : '';
                  const attendeeLabel = callWithTitle(item);
                  const actionFlag = callActionFlag(item, userId);
                  const handleDetailsClick = () => handleSeeBookingDetails(item?.participantsUser, item?._id);

                  return (
                    <Box className="CallsTableBox" key={item?._id} data-testid="calendar-event">
                      <Box className="MeetingCard">
                        <Box className="MeetingCardMain" onClick={handleDetailsClick}>
                          <Box className="MeetingCardDate">
                            <Box className="MeetingCardDateMonth" sx={{ backgroundColor: statusData.color }}>
                              <Typography sx={{color: 'white'}}>{month}</Typography>
                            </Box>
                            <Box className="MeetingCardDateDay">
                              <Typography className="MeetingCardDateNumber">{day}</Typography>
                              <Typography className="MeetingCardDateWeekday">{weekday}</Typography>
                            </Box>
                          </Box>
                          <Box className="MeetingCardDetails">
                            <Typography variant="h5" className="MeetingCardTitle">
                              {item?.callTitle}
                            </Typography>
                            <Box className="MeetingCardMeta">
                              {meetingTimeLabel && (
                                <Box className="MeetingCardMetaItem">
                                  <AccessTimeIcon className="MeetingCardMetaClock" fontSize="inherit" />
                                  <Typography className="MeetingCardMetaText">{meetingTimeLabel}</Typography>
                                </Box>
                              )}
                              {durationLabel && (
                                <>
                                  <span className="MeetingCardMetaDivider" />
                                  <Typography className="MeetingCardMetaText">{durationLabel}</Typography>
                                </>
                              )}
                              {attendeeLabel && (
                                <>
                                  <span className="MeetingCardMetaDivider" />
                                  <Typography className="MeetingCardMetaText">{attendeeLabel}</Typography>
                                </>
                              )}
                            </Box>
                          </Box>
                        </Box>
                        <Box className="MeetingCardCtas">
                          {item.meetingType !== 'InPerson' && actionFlag === 1 ? (
                            <Box className="MeetingCardActionButtons">
                              {rejectCancelCallButton(item, 'page')}
                              {joinCallButton(item, 'page')}
                            </Box>
                          ) : (
                            <Button
                              variant="contained"
                              color="primary"
                              className="MeetingCardDetailsBtn"
                              onClick={handleDetailsClick}
                            >
                              Details
                            </Button>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
          </Box>

        </Box>

        {/* Rejection Reason modal */}
        {openRejectionCall && (
          <RejectionCallModal
            openRejectionCall={openRejectionCall}
            closeRejectionModal={closeRejectionModal}
            callMeetingId={callMeetingId}
            onRejectSuccess={handleCallRejection}
          />
        )}

        {/* Cancelation Reason modal */}
        {openCancelationCall && (
          <CancelationCallModal
            openCancelationCall={openCancelationCall}
            closeCancelModal={closeCancelModal}
            callMeetingId={callMeetingId}
            onCancelSuccess={handleCallCancellation}
          />
        )}

        {/* See Booking Details Modal */}
        {openCallbookingDetailsModal && (
          <SeeBookingDetailsModal
            openCallbookingDetailsModal={openCallbookingDetailsModal}
            closeSeeBookingDetailsModal={closeSeeBookingDetailsModal}
            bookedCallDetails={bookedCallDetails[0]}
            allattendeeDetails={allattendeeDetails}
            timezone={timezone}
            ModalDialogActions={<></>}
            userCallsDataRefetch={userCallsDataRefetch}
            isCallRejectedByAuthUser={true}
            setIsCallEditing={setIsCallEditing}
            isCallEditing={isCallEditing}
          />
        )}
        {/* {userProfileDetails?.mentee?.length > 0 && filteredCallRows.length > 0 && (
          <PostCallPopup
            key={currentMeetingIndex}
            reviewParticipant={filteredCallRows[currentMeetingIndex].participantsUser}
            openPostCallPopup={openPostCallPopup}
            handleClosePostCallPopup={openNextPopup} // Move to the next meeting after closing the popup
            meetingId={filteredCallRows[currentMeetingIndex].meetingId}
            title={`Please review your meeting with\n${callWithTitle(filteredCallRows[currentMeetingIndex])}`}
          />
        )} */}

        {/* Call Booking Modal */}
        <CallBookingModal
          handleCloseModal={() => setCalendarOpen(false)}
          openFlag={isCalendarOpen}
          chatProfileName={''}
          threadParticipantsUsers={[]}
          chatType="Chats"
          pageName="Calendar"
          bookedCallDetails={''}
        />
      </Box>
    </Box>
  );
};

export default Calendar;
